/* eslint-disable */
// prettier-ignore-start
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';
import { IFooterProps } from '../../types/IFooter';

/**
 *
 * @param param
 * @returns
 */
const Footer = ({
  backgroundColor,
  displayLogo,
  logo,
  logoURL,
  topBoderColor,
  logoWidth,
  borderTopWidth,
  logoAltText,
  links,
}: IFooterProps) => {
  const footerStyle = {
    borderTopColor: topBoderColor ? topBoderColor : '021f40',
    backgroundColor: backgroundColor ? backgroundColor : '#f2f2f2',
    borderTopWidth:
      borderTopWidth && borderTopWidth >= 0 ? borderTopWidth + 'px' : '0px',
  };

  const defaultLink =
    links && links.length > 0
      ? links.map((val, index) => {
          return (
            <Col md="auto" key={`${val.name}_${index}`}>
              {
                val.target=="self"?
                 <a
                key={index}
                style={{ color: '#021f40' }}
                className="footer-links"
                href={val.url } 
                target="_blank"
                >
                {val.name}
                </a>
                :
                <Link
                key={index}
                style={{ color: '#021f40' }}
                className="footer-links"
                to={{ pathname: val.url }}
              >
                {val.name}
              </Link>}
            </Col>
          );
        })
      : [];

  const brandLogo = (
    <img
      src={logo}
      width={logoWidth ? logoWidth : 'auto'}
      alt={logoAltText ? logoAltText : 'NTIS'}
      className="site-logo"
    />
  );

  const brandLink = logoURL ? <Link to={logoURL}>{brandLogo}</Link> : brandLogo;

  return (
    <footer className="site-footer" style={footerStyle}>
      <Container>
        <Row>
          {displayLogo && (
            <Col md={4} sm={12} className="p-0">
              {logo && brandLink}
            </Col>
          )}
          <Col md={12} sm={12} className="p-0">
            <Row className="justify-content-md-end">{defaultLink}</Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
